// /frontend/src/components/GenericForm.js

import React from 'react';
import { TextField, Grid, MenuItem, FormControl, InputLabel, Select, Autocomplete, Button, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const GenericForm = ({ fields, formData, setFormData }) => {
  
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({ ...prev, [name]: files ? files[0] : value }));
  };

  const handleAutocompleteChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const renderField = (field) => {
    switch (field.type) {
      case 'select':
        return (
          <FormControl fullWidth required={field.required}>
            <InputLabel>{field.label}</InputLabel>
            <Select
              name={field.name}
              label={field.label}
              value={formData[field.name] || ''}
              onChange={handleChange}
            >
              {field.options.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case 'autocomplete':
        return (
          <Autocomplete
            multiple
            options={field.options || []}
            getOptionLabel={(option) => option.name}
            value={formData[field.name] || []}
            onChange={(event, newValue) => {
              handleAutocompleteChange(field.name, newValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                placeholder="Seleziona..."
                // Require only when no selections; avoids HTML5 "Compila questo campo" with existing values
                required={field.required && (!formData[field.name] || formData[field.name].length === 0)}
              />
            )}
          />
        );
      
      case 'textarea':
        return (
           <TextField
            fullWidth
            multiline
            rows={4}
            name={field.name}
            label={field.label}
            value={formData[field.name] || ''}
            onChange={handleChange}
            required={field.required}
            helperText={field.helperText || ''}
            InputLabelProps={field.InputLabelProps || {}}
          />
        );

      case 'date':
         return (
           <TextField
            fullWidth
            type="date"
            name={field.name}
            label={field.label}
            value={formData[field.name] ? new Date(formData[field.name]).toISOString().split('T')[0] : ''}
            onChange={handleChange}
            required={field.required}
            InputLabelProps={{ shrink: true }}
          />
         );
      
      case 'file':
        return (
          <FormControl fullWidth>
            <Typography 
              component="label" 
              htmlFor={`upload-${field.name}`} 
              variant="body1" 
              sx={{ color: 'rgba(0, 0, 0, 0.6)', mb: 1, display: 'block' }}
            >
              {field.label}
            </Typography>
            <Button
              variant="outlined"
              component="label"
              htmlFor={`upload-${field.name}`}
              startIcon={<UploadFileIcon />}
            >
              Seleziona File
              <input
                id={`upload-${field.name}`}
                type="file"
                name={field.name}
                hidden
                onChange={handleChange}
              />
            </Button>
            {formData[field.name] && typeof formData[field.name] === 'object' ? (
              <Typography variant="body2" sx={{ mt: 1 }}>
                File selezionato: {formData[field.name].name}
              </Typography>
            ) : formData[field.name] && typeof formData[field.name] === 'string' ? (
              <Typography variant="body2" sx={{ mt: 1 }}>
                File caricato: {formData[field.name].split('/').pop()}
              </Typography>
            ) : null}
          </FormControl>
        );

      default: // 'text', 'email', 'tel'
        return (
          <TextField
            fullWidth
            type={field.type}
            name={field.name}
            label={field.label}
            value={formData[field.name] || ''}
            onChange={handleChange}
            required={field.required}
            InputLabelProps={field.InputLabelProps || {}}
          />
        );
    }
  };

  return (
    <Grid container spacing={2}>
      {fields.map(field => (
        <Grid item xs={12} sm={field.gridSpan || 12} key={field.name}>
          {renderField(field)}
        </Grid>
      ))}
    </Grid>
  );
};

export default GenericForm;